// extracted by mini-css-extract-plugin
export default {"content":"FullScreenImageModal_content__43N8G","actions":"FullScreenImageModal_actions__VruCH","imageUpload":"FullScreenImageModal_imageUpload__mBOIn"};